 // /home/clement/compta-app/client/src/components/Facturation/StatistiquesFacturation.js
 
import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Paper, CircularProgress } from '@mui/material';
import { Pie, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { fetchStatistiquesFacturation } from '../../api/statistiquesApi';

// Enregistrer les composants ChartJS nécessaires
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const StatistiquesFacturation = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadStats = async () => {
      try {
        const data = await fetchStatistiquesFacturation();
        setStats(data);
      } catch (err) {
        setError("Erreur lors du chargement des statistiques.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadStats();
  }, []);

  if (loading) return <CircularProgress />;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!stats) return null;

  // Données pour le PieChart (répartition par client)
  const pieData = {
    labels: stats.repartitionClients.map(client => client.nom),
    datasets: [
      {
        data: stats.repartitionClients.map(client => client.montant),
        backgroundColor: [
          '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'
        ],
      },
    ],
  };

  // Données pour le BarChart (évolution mensuelle)
  const barData = {
    labels: stats.evolutionMensuelle.map(item => item.mois),
    datasets: [
      {
        label: 'Chiffre d\'affaires mensuel (€)',
        data: stats.evolutionMensuelle.map(item => item.montant),
        backgroundColor: '#36A2EB',
      },
    ],
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Statistiques de Facturation
      </Typography>

      {/* Cartes synthétiques */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="h6">Chiffre d'Affaires</Typography>
            <Typography variant="h4">{stats.chiffreAffaires?.toFixed(2) || '0.00'} €</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="h6">Factures émises</Typography>
            <Typography variant="h4">{stats.nbFacturesVente || 0}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="h6">Factures reçues</Typography>
            <Typography variant="h4">{stats.nbFacturesAchat || 0}</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Paper sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="h6">Moyenne par facture</Typography>
            <Typography variant="h4">
              {stats.nbFacturesVente ? (stats.chiffreAffaires / stats.nbFacturesVente).toFixed(2) : '0.00'} €
            </Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Graphiques */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Répartition par client (Top 5)
            </Typography>
            <Pie data={pieData} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Évolution mensuelle du CA
            </Typography>
            <Bar data={barData} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StatistiquesFacturation;
